import { bootstrapApplication } from '@angular/platform-browser';
import { configureAppWithProjectConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

declare global {
  interface Window {
    __project: {
      config: any;
      env: any;
    };
  }
}

const loadConfig = () => {
  const {domainUrl} = environment;
  let domain = new URL(window.location.origin).hostname;

  if(domainUrl){
    domain = new URL(`https://${domainUrl}.com`).hostname; //Build para genera localhost
  }

  if(domain.includes('localhost')) {
    return Promise.resolve();
  }

  const parts = domain.split('.');
  let projectName = parts[0];
  if(projectName === 'www') {
    projectName = parts[1];
  }

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = `projects/${projectName}.js?t=${Date.now()}`;
    script.onload = resolve;
    script.onerror = resolve;
    document.head.appendChild(script);
  });
};


loadConfig().then(() => {
  const configuredApp = configureAppWithProjectConfig(window.__project);

  bootstrapApplication(AppComponent, configuredApp)
    .catch((err) => console.error(err));
});
